import { CardHeader, Typography, useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
import BoxWithBackground from './BoxWithBackground'
import RowStack from './RowStack'
import AcceptRejectButtons from '../button/AcceptRejectButtons'
import { getFullName } from 'utils/formatText'

const FeedbackItemContainer = ({
  subHeader,
  user,
  acceptLabel,
  acceptAction,
  rejectAction,
  title,
  acceptButtonProps = {},
  updatedStyle = true,
  children
}) => {
  const theme = useTheme()
  const cardTitle = title ? title : getFullName(user)
  return (
    <Grid size={updatedStyle ? 12 : 6} minWidth='400px'>
      <BoxWithBackground
        backgroundColor={
          updatedStyle
            ? theme.palette.background.paper
            : theme.palette.background.default
        }
        width='100%'
        borderRadius={4}
        padding={8}
        paddingRight={rejectAction ? 1 : 8}>
        <RowStack justifyContent='space-between'>
          <CardHeader
            subheader={
              subHeader ? (
                <Typography variant='body1Small' color='textSecondary'>
                  {subHeader}
                </Typography>
              ) : undefined
            }
            title={
              updatedStyle ? (
                <Typography variant='h4'>{cardTitle}</Typography>
              ) : (
                cardTitle
              )
            }
            sx={{ padding: 0 }}
          />
          {acceptLabel && <AcceptRejectButtons
            acceptLabel={acceptLabel}
            onAccept={acceptAction}
            onReject={rejectAction}
            background={theme.palette.background.paper}
            acceptButtonProps={acceptButtonProps}
          />}
          {children}
        </RowStack>
      </BoxWithBackground>
    </Grid>
  )
}

export default FeedbackItemContainer
